// extracted by mini-css-extract-plugin
export default {"container":"pieChart_container__scCgO"};